export default __webpack_public_path__ + "static/media/pokemon_illustration_rare.c7599ab9.svg";